module.exports = __webpack_public_path__ + "img/EmptyState.434a8775.svg";